import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/transactions', {
          params: payload,
        })
        .then(response => {
          commit('SET_TRANSACTIONS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchRecord(context, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/transactions/${docNo}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  refreshRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/transactions/status/refresh', payload)
        .then(response => {
          commit('UPDATE_TRANSACTION', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addRecords({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/transactions/bulk', { bulk: items })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeRecord({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/transactions/delete/${docNo}`)
        .then(response => {
          commit('DELETE_TRANSACTION', docNo)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  approveRecord({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/transactions/${docNo}/approve`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  approveRecords({ commit }, docs) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/transactions/approve`, docs)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  rejectRecord({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/transactions/${docNo}/reject`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateBulk({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/transactions/updateBulk', { bulk: items })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
